import { SelectOptionType } from "../../../types/types";

/**
 * What the Contacts lists remember while a client is open (Roadmap 1851):
 * the search text and, on the Active tab, the Tags / Organization type /
 * Year end filters. Page and sort are in the address already.
 */
export type ContactsListMemory = {
  search: string;
  filters: {
    tagsValues: SelectOptionType[];
    organizationTypes: SelectOptionType[];
    yearEnd: SelectOptionType[];
  };
  /** Client owner / Client manager filters (people ids or "me"); only kept when set. */
  team?: { owners: string[]; managers: string[] };
};

const ids = (value: unknown): string[] =>
  Array.isArray(value)
    ? value.filter((item): item is string => typeof item === "string")
    : [];

const options = (value: unknown): SelectOptionType[] =>
  Array.isArray(value)
    ? value
        .filter(
          (item) =>
            item &&
            typeof item === "object" &&
            typeof item.value === "string" &&
            typeof item.label === "string",
        )
        .map((item) => ({ ...item }))
    : [];

/** Saved state (from storage, so checked) or the empty starting state. */
export const restoreContactsList = (saved: unknown): ContactsListMemory => {
  const record =
    saved && typeof saved === "object"
      ? (saved as Partial<ContactsListMemory>)
      : {};
  const filters = (
    record.filters && typeof record.filters === "object" ? record.filters : {}
  ) as Partial<ContactsListMemory["filters"]>;
  const team = {
    owners: ids(record.team?.owners),
    managers: ids(record.team?.managers),
  };
  return {
    search: typeof record.search === "string" ? record.search : "",
    ...(team.owners.length || team.managers.length ? { team } : {}),
    filters: {
      tagsValues: options(filters.tagsValues),
      organizationTypes: options(filters.organizationTypes),
      yearEnd: options(filters.yearEnd),
    },
  };
};
